import styled from "styled-components";

export const Button = styled.button`
  background-color: #a400cf;
  color: white;
  border-radius: 60% 60% 60% 60% !important;
  padding: 1% !important;
`;
